import { url } from '../c-mp/fun/url'
import type { PersonImageSize } from '../model/PersonImageSize'
import { getServerUrl } from './getServerUrl'

export function getPersonImageUrl(
	personId: string,
	{
		fileName,
		size,
		emptyIfMissing,
	}: {
		fileName?: string
		size?: PersonImageSize | null | undefined
		emptyIfMissing?: boolean
	} = {},
) {
	return (
		getServerUrl() +
		url`/image/${size ?? 'default'}/or/${emptyIfMissing ? 'empty' : 'missing'}/${personId}` +
		(fileName ? url`/${fileName}` : '')
	)
}
